// @flow
import type {TripQuery} from '../utils/tripData';

type TripDataChangedActionType = 'TRIP/DATA_CHANGED';
export type ActionType = TripDataChangedActionType;

type TripDataChangedAction = {
    type: TripDataChangedActionType,
    payload: TripQuery
};
export type Action = TripDataChangedAction;

const ACTION_CREATORS = {
    tripDataChanged(tripData: TripQuery): TripDataChangedAction {
        return {
            type: 'TRIP/DATA_CHANGED',
            payload: {
                ...tripData
            }
        };
    }
};

export default {
    ...ACTION_CREATORS
};
